/**
 * EmptyValue — Iter52 P16
 *
 * Badge mic care înlocuiește placeholderul "—" pentru valorile lipsă. Tooltip
 * pe hover explică motivul (necompletat / nu se aplică / nesetat etc.).
 *
 * Usage:
 *   <EmptyValue />                              // default "necompletat"
 *   <EmptyValue reason="notApplicable" />       // "nu se aplică"
 *   <EmptyValue reason="pending" />             // "în așteptare"
 *   <EmptyValue tooltip="Custom..." />          // override tooltip text
 */
const REASONS = {
  notFilled: {
    label: "necompletat",
    tooltip: "Acest câmp nu a fost completat încă. Click „Editează” pentru a-l adăuga sau așteaptă următoarea sincronizare.",
    className: "bg-slate-50 text-slate-500 border-slate-200",
  },
  notApplicable: {
    label: "nu se aplică",
    tooltip: "Câmpul nu este aplicabil pentru acest tip de vânzare/produs.",
    className: "bg-slate-100 text-slate-400 border-slate-200",
  },
  pending: {
    label: "în așteptare",
    tooltip: "Valoarea va fi populată automat după o acțiune ulterioară (sync SF, validare, activare etc.).",
    className: "bg-amber-50 text-amber-700 border-amber-200",
  },
  fromImport: {
    label: "așteaptă import",
    tooltip: "Acest câmp este populat automat la următorul import Salesforce / Easy.",
    className: "bg-indigo-50 text-indigo-700 border-indigo-200",
  },
};

export const EmptyValue = ({
  reason = "notFilled",
  tooltip,
  label,
  className = "",
  testId,
}) => {
  const r = REASONS[reason] || REASONS.notFilled;
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium border ${r.className} ${className}`}
      title={tooltip || r.tooltip}
      data-testid={testId || "empty-value"}
    >
      {label || r.label}
    </span>
  );
};

export default EmptyValue;
